// extracted by mini-css-extract-plugin
export default {"flag":"style_flag__B1GDF"};